import React, { FC } from 'react';
import { useInformationalAlert } from './contextProviders';
import { InformationalAlert } from './jsxElements/InformationalAlert';

const GlobalInformationAlert: FC = () => {
    const { informationalAlertContent } = useInformationalAlert();

    return (
        <>
            <InformationalAlert content={informationalAlertContent} />
        </>
    );
};

export default GlobalInformationAlert;
